import { useTranslation } from 'react-i18next';
import { LineItem } from '@pperform/pp-data-mappers';
import {
  getDisplayPrice,
  getDisplayProductImageUrl,
} from 'utils/lineItem.utils';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { getNestField } from '../../../../../utils/object.utils';
import { snakeToCamel } from '../../../../../utils/string.utils';

export interface Option<T = string | number> {
  label: string;
  value: T;
}
interface ReturnValues {
  productName: string;
  quantity: number;
  productImageUrl?: string;
  productPrice?: Option<string>;
  additionalInformation: string;
  productID: Option<string>;
}

const useLineItemCommonDisplayInfo = (lineItem: LineItem): ReturnValues => {
  const { t } = useTranslation();
  const ptpConfig = usePTPConfigContext();
  const { lineItem: lineItemConfig } = ptpConfig;
  const {
    displayImages,
    productDescription,
    displayAdditionalLineItemFieldEnabled,
    displayAdditionalLineItemFields,
    displayProductIdEnabled,
  } = lineItemConfig;
  const { showPrice } = productDescription;

  const { productName, quantity } = lineItem;

  const productPrice = {
    label: t('LINE_ITEMS_PRICE'),
    value: getDisplayPrice(lineItem),
  };

  const productImageUrl = getDisplayProductImageUrl(lineItem, ptpConfig);

  let additionalFields = [];

  if (displayAdditionalLineItemFieldEnabled) {
    additionalFields = additionalFields
      .concat(
        displayAdditionalLineItemFieldEnabled &&
          displayAdditionalLineItemFields?.map(
            (field) =>
              field.isEnabled &&
              getNestField(lineItem.additionalInfo, field.fieldName),
          ),
      )
      .filter(Boolean);
  }

  const additionalInformation =
    additionalFields.join(' / ') ||
    (displayAdditionalLineItemFieldEnabled && ' ');

  const productID = displayProductIdEnabled
    ? {
        label: 'ID',
        value: lineItem.productId || '-',
      }
    : null;

  return {
    ...(lineItemConfig.isEnabled && displayImages && { productImageUrl }),
    ...(showPrice && { productPrice }),
    productName,
    quantity,
    additionalInformation,
    productID,
  };
};

export { useLineItemCommonDisplayInfo };
